(function () {
  function bindWrapper(wrap) {
    if (!wrap || wrap.dataset.myalephTapPlay === '1') return;
    var video = wrap.querySelector('video[data-video-autoplay], video');
    if (!video) return;
    wrap.dataset.myalephTapPlay = '1';

    function tryPlay() {
      if (!video.paused) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          try {
            video.muted = true;
            video.setAttribute('playsinline', '');
            var p2 = video.play();
            if (p2 && typeof p2.catch === 'function') {
              p2.catch(function () {
                video.controls = true;
              });
            }
          } catch (e) {
            video.controls = true;
          }
        });
      }
    }

    wrap.addEventListener('click', function () {
      tryPlay();
    }, true);
    wrap.addEventListener(
      'touchend',
      function () {
        tryPlay();
      },
      { capture: true, passive: true }
    );

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryPlay();
          });
        },
        { threshold: 0.25 }
      );
      io.observe(video);
    } else {
      tryPlay();
    }
  }

  function scan() {
    document.querySelectorAll('.video-autoplay-wrapper').forEach(bindWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
